import { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import { isClabeReady, sanitizeClabeInput } from '../utils/phase4Flow';

const ClabeScreen = ({
  literals,
  message = '',
  messageTone = '',
  isSubmitting = false,
  onVerify,
  onContinue,
  onBack,
}) => {
  const [clabe, setClabe] = useState('');
  const [validatedClabe, setValidatedClabe] = useState('');
  const validated = isClabeReady(clabe) && clabe === validatedClabe;

  const handleChange = (value) => {
    setClabe(sanitizeClabeInput(value));
  };

  const handleVerify = async () => {
    if (!isClabeReady(clabe) || isSubmitting) return;
    const result = await onVerify(clabe);
    if (result === 'validated') {
      setValidatedClabe(clabe);
      return;
    }
    setValidatedClabe('');
  };

  return (
    <div className='full-screen-container digital-loan-preoffer'>
      <div className='screen-content digital-loan-preoffer__scroll'>
        <h1 className='digital-loan-phase2__title'>{literals.title}</h1>
        <p className='digital-loan-phase2__body mb-3'>{literals.body}</p>
        <p className='digital-loan-phase2__body mb-4'>{literals.holder}</p>
        <label className='digital-loan-summary-block__label' htmlFor='digital-loan-clabe'>
          {literals.label}
        </label>
        <input
          id='digital-loan-clabe'
          className='form-control mt-2'
          inputMode='numeric'
          autoComplete='off'
          name='clabe'
          value={clabe}
          aria-invalid={messageTone === 'invalid'}
          onChange={(event) => handleChange(event.target.value)}
        />
        <button
          type='button'
          className='btn btn-link px-0 mt-2'
          disabled={!isClabeReady(clabe) || isSubmitting}
          onClick={handleVerify}
        >
          {literals.verify}
        </button>
        {message && (
          <p
            className='digital-loan-phase2__body mt-3'
            role={messageTone === 'validated' ? 'status' : 'alert'}
          >
            {message}
          </p>
        )}
      </div>
      <div className='screen-actions'>
        <Button
          text={literals.submit}
          disabled={!validated || isSubmitting}
          onClick={onContinue}
        />
        <Button
          text={literals.back}
          type='secondary'
          disabled={isSubmitting}
          onClick={onBack}
        />
      </div>
    </div>
  );
};

ClabeScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  message: PropTypes.string,
  messageTone: PropTypes.string,
  isSubmitting: PropTypes.bool,
  onVerify: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default ClabeScreen;
